import { useContext } from "react";
import AuthContext, { type AuthContextValue } from "src/contexts/JWTAuthContext";

export function useAuth(): AuthContextValue {
    return useContext(AuthContext);
}

export default useAuth;
